export default "__VITE_ASSET__5815611d__"